import { ITaskConstructor } from 'Core/TaskAdapter'
import { UseCaseTypes } from 'Types/Tasks.types'
import { GenerationTask } from './GenerationTask/GenerationTask'
import { TaskRegistry } from 'Core/TaskRegistry'

type TaskRegistrationType = {
    type: UseCaseTypes
    taskKey: string
    task: ITaskConstructor
}

export const registerTasks = () => {
    const taskRegistry = TaskRegistry.getInstance()
    tasks.forEach(task => {
        taskRegistry.registerTask(task)
    })
}

// Add custom tasks here along with interface/task key
export const tasks: TaskRegistrationType[] = [
    {
        type: UseCaseTypes.SFT_GENERATION_RESPONSE_GENERATION,
        taskKey: 'craving-ui-v1',
        task: GenerationTask,
    },
]
